import { SearchConfig, SearchKey } from "../../../../types/search";

type OptionKeys = Extract<
  SearchKey,
  "propertyName" | "unitCode" | "propertyCode" | "location" | "businessUnitId" | "ownerName" | "recordNumber"
>;

export const searchByOptions: SearchConfig<OptionKeys>[] = [
  { value: "propertyName", label: "Property Name", controlType: "text" },
  { value: "unitCode", label: "Unit No", controlType: "text" },
  { value: "propertyCode", label: "Property Code", controlType: "text" },
  { value: "location", label: "Location", controlType: "text" },
  { value: "businessUnitId", label: "Business Unit", controlType: "select" },
  { value: "ownerName", label: "Owner", controlType: "select" },
  { value: "recordNumber", label: "ID", controlType: "text" },
];
